import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-consult-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfConsultIconProps extends SvgIconProps  { }

/**
 * Component for showing consult icon
 * @param props -CcfConsultIconProps
 * @returns consult svg icon
 * @example -<CcfConsultIcon/>
 */
export function CcfConsultIcon(props: CcfConsultIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="Consult">
        <g id="Group_118901" data-name="Group 118901" transform="translate(-567.202 -198.004)">
          <g id="Group_118592" data-name="Group 118592" transform="translate(15977.873 12366.004)">
            <circle id="Ellipse_4689" data-name="Ellipse 4689" cx="3.511" cy="3.511" r="3.511" transform="translate(-15407.446 -12165.5)" />
            <path id="Intersection_1" data-name="Intersection 1" d="M0,6A6.064,6.064,0,0,1,12.127,6,16.754,16.754,0,0,1,6.064,7.021,16.753,16.753,0,0,1,0,6Z" transform="translate(-15410 -12158.16)" />
            <g id="Group_118568" data-name="Group 118568" transform="translate(-15402.766 -12163.266)">
              <g id="Rectangle_80257" data-name="Rectangle 80257" transform="translate(0 0)" stroke="#707070" strokeWidth="1" opacity="0">
                <rect width="12.766" height="12.766" stroke="none" />
                <rect x="0.5" y="0.5" width="11.766" height="11.766" fill="none" />
              </g>
              <g id="Group_118188" data-name="Group 118188" transform="translate(1.277 1.915)">
                <g id="Group_118393" data-name="Group 118393">
                  <g id="Rectangle_80257-2" data-name="Rectangle 80257" stroke="#707070" strokeWidth="1" opacity="0">
                    <rect width="9.574" height="9.574" stroke="none" />
                    <rect x="0.5" y="0.5" width="8.574" height="8.574" fill="none" />
                  </g>
                  <g id="Group_118387" data-name="Group 118387" transform="translate(0.517 0.517)">
                    <g id="Group_118385" data-name="Group 118385">
                      <g id="Path_24922" data-name="Path 24922">
                        <path d="M 4.415672302246094 8.331342697143555 C 2.256562232971191 8.331342697143555 0.5000023245811462 6.574782371520996 0.5000023245811462 4.415672302246094 C 0.5000023245811462 2.256562232971191 2.256562232971191 0.5000023245811462 4.415672302246094 0.5000023245811462 C 6.574782371520996 0.5000023245811462 8.331342697143555 2.256562232971191 8.331342697143555 4.415672302246094 C 8.331342697143555 6.574782371520996 6.574782371520996 8.331342697143555 4.415672302246094 8.331342697143555 Z" stroke="none" />
                        <path d="M 4.415672302246094 1.000002384185791 C 2.532262325286865 1.000002384185791 1.000002384185791 2.532262325286865 1.000002384185791 4.415672302246094 C 1.000002384185791 6.299082279205322 2.532262325286865 7.831342220306396 4.415672302246094 7.831342220306396 C 6.299082279205322 7.831342220306396 7.831342220306396 6.299082279205322 7.831342220306396 4.415672302246094 C 7.831342220306396 2.532262325286865 6.299082279205322 1.000002384185791 4.415672302246094 1.000002384185791 M 4.415672302246094 1.9073486328125e-06 C 6.854382514953613 1.9073486328125e-06 8.831342697143555 1.976962089538574 8.831342697143555 4.415672302246094 C 8.831342697143555 6.854382514953613 6.854382514953613 8.831342697143555 4.415672302246094 8.831342697143555 C 1.976962089538574 8.831342697143555 1.9073486328125e-06 6.854382514953613 1.9073486328125e-06 4.415672302246094 C 1.9073486328125e-06 1.976962089538574 1.976962089538574 1.9073486328125e-06 4.415672302246094 1.9073486328125e-06 Z" stroke="none" fill="#fff" />
                      </g>
                      <path id="plus" d="M7.941,5.839H6.364V4.263a.263.263,0,1,0-.525,0V5.839H4.263a.263.263,0,1,0,0,.525H5.839V7.941a.263.263,0,1,0,.525,0V6.364H7.941a.263.263,0,1,0,0-.525Z" transform="translate(-1.686 -1.686)" stroke="#fff" strokeWidth="1" />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfConsultIcon;
